import { useMemo } from "react";
import {
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import LoginPage from "./pages/Login/Login";
import OldForm from "./pages/Form/Form.old";
import Form from "./pages/Form/Form";
import OldAssessment from "./pages/Assessment/Assessment.old";
import { getToken } from "./auth";
import ThankYouPage from "./pages/Thankyou";
import { useNavigate } from "react-router-dom";
import Assessment from "./pages/Assessment/Assessment";
import TestPage from "./pages/test";

const App = () => {
  const loginToken = getToken();
  const navigate = useNavigate();

  const isLoggedIn = !!loginToken;
  // const isLoggedIn = true;
  const isActive = loginToken?.status === "Active";

  const isFormSubmitted = useMemo(() => isActive, [isActive]);

  return (
    <>
      <Routes>
        <Route path="/form" element={<Form />} />
        <Route path="/assessment" element={<Assessment />} />
        {/* <Route path="/devtest" element={<TestPage />} /> */}


        {/* <Route path="/thankyou" element={<ThankYouPage />} />
        {!isLoggedIn ? (
          <Route
            path="*"
            element={<LoginPage onLogin={(path) => navigate(path ||"/")} />}
          />
        ) : (
          <>
            <Route
              path="/"
              element={
                isActive ? (
                  <Navigate to="/oldassessment" replace />
                ) : (
                  <Navigate to="/oldform" replace />
                )
              }
            />

            <Route
              path="/oldform"
              element={
                isActive ? (
                  <Navigate to="/oldassessment" replace />
                ) : (
                  <OldForm onSubmit={() => navigate("/oldassessment")}/>
                )
              }
            />

            <Route
              path="/oldassessment"
              element={
                isActive || isFormSubmitted ? (
                  <OldAssessment />
                ) : (
                  <Navigate to="/oldform" replace />
                )
              }
            />
            
            <Route path="*" element={<Navigate to="/" replace />} />  
          </>
        )}  */}
      </Routes>
    </>
    
  );
};

export default App;
